import React, { useState } from 'react';

import { Modal } from 'components/modals/components/modal';
import { SimpleInfoModalBody } from 'components/modals/simpleInfoModal/components/simpleInfoModalBody';
import { ReactPortal } from 'components/reactPortal';
import { SportResultsAndInfoContent } from 'features/sport/components/sportResultsAndInfoContent';
import { StatisticType } from 'features/sport/utils/betRadar/statisticTypeEnum';
import { useBlockScroll } from 'hooks/useBlockScroll';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { ScommesseTableStatsTrigger } from './scommesseTableStatsTrigger';

export type ScommesseTableStatsProps = {
  providerID?: number;
  className?: string;
  title?: string;
};

export const ScommesseTableStats = ({ providerID, className, title }: ScommesseTableStatsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [resultAndInfoLabel] = useGetLabelsByKeys(['risultati-ed-info']);
  useBlockScroll(isOpen);

  return (
    <React.Fragment>
      <ScommesseTableStatsTrigger setIsOpen={setIsOpen} className={className} />

      {providerID && isOpen && (
        <ReactPortal wrapperId="sport-stats">
          <Modal
            label={title ? title : resultAndInfoLabel}
            modalType="tertiary"
            modalCategory="simple-modal"
            onClose={() => setIsOpen(false)}
          >
            <SimpleInfoModalBody>
              <SportResultsAndInfoContent
                isOpen
                providerID={providerID}
                type={StatisticType.Avvenimento}
                id={providerID}
                key={providerID}
              />
            </SimpleInfoModalBody>
          </Modal>
        </ReactPortal>
      )}
    </React.Fragment>
  );
};
